import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { AgreementTemplateService } from '../../../quan-ly-loai-tai-lieu/tai-lieu-mau/AgreementTemplateService';

interface TemplateSelectionDialogProps {
    visible: boolean;
    onHide: () => void;
    onSelect: (template: any) => void;
}

export const TemplateSelectionDialog: React.FC<TemplateSelectionDialogProps> = ({
    visible,
    onHide,
    onSelect
}) => {
    const [templates, setTemplates] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState<any>(null);

    useEffect(() => {
        if (visible) {
            loadTemplates();
        } else {
            setSelectedTemplate(null);
            setKeyword('');
        }
    }, [visible]);

    const loadTemplates = (search?: string) => {
        setLoading(true);
        const lazyEvent = JSON.stringify({
            first: 0,
            rows: 100,
            sortField: 'agreementDate',
            sortOrder: -1
        });
        const params: any = { disabled: 'N', textSearch: search?.trim() };
        AgreementTemplateService.findAgreementList(params)
            .then((res: any) => {
                const list = res?.listData || res?.data || [];
                setTemplates(Array.isArray(list) ? list : []);
            })
            .catch(() => setTemplates([]))
            .finally(() => setLoading(false));
    };

    const handleSearch = () => {
        loadTemplates(keyword);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') handleSearch();
    };

    const handleConfirm = () => {
        if (selectedTemplate) {
            onSelect(selectedTemplate);
        }
    };

    return (
        <Dialog
            header="Chọn tài liệu mẫu"
            visible={visible}
            style={{ width: '60vw' }}
            modal
            onHide={onHide}
            footer={
                <div className="flex justify-content-end gap-2">
                    <Button label="Đóng" icon="pi pi-times" outlined severity="secondary" onClick={onHide} />
                    <Button label="Chọn mẫu này" icon="pi pi-check" disabled={!selectedTemplate} onClick={handleConfirm} />
                </div>
            }
        >
            <div className="flex align-items-center gap-2 mb-3">
                <InputText
                    value={keyword}
                    onChange={e => setKeyword(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="Tìm kiếm mẫu tài liệu..."
                    className="flex-1"
                />
                <Button icon="pi pi-search" onClick={handleSearch} />
            </div>

            <DataTable
                value={templates}
                loading={loading}
                selectionMode="single"
                selection={selectedTemplate}
                onSelectionChange={e => setSelectedTemplate(e.value)}
                dataKey="agreementId"
                scrollable
                scrollHeight="400px"
                emptyMessage="Không tìm thấy mẫu tài liệu nào"
                className="p-datatable-sm"
            >
                <Column field="agreementPseudoId" header="Mã mẫu" style={{ width: '130px' }} />
                <Column field="agreementName" header="Tên tài liệu mẫu" style={{ width: '280px' }} />
                <Column field="fileName" header="Tên file" style={{ width: '250px' }} />
                <Column field="description" header="Mô tả" />
            </DataTable>
        </Dialog>
    );
};
